import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Recycle } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Home screen entry for used parts sellers — routes to unified partner signup.
 */
const UsedPartsSellerCta = () => {
  const navigate = useNavigate();
  const { isDark } = useTheme();

  const handleClick = () => {
    navigate('/signup');
  };

  return (
    <motion.section
      className="mx-auto w-full max-w-6xl px-3 py-4 sm:px-4 sm:py-5"
      initial={{ opacity: 0, y: 8 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.35 }}
      aria-label="Sell used parts"
    >
      <div
        className={
          isDark
            ? 'relative overflow-hidden rounded-2xl border border-emerald-500/30 bg-gradient-to-r from-slate-900 via-slate-800 to-emerald-950 px-4 py-5 sm:px-6 sm:py-6'
            : 'relative overflow-hidden rounded-2xl border border-emerald-200 bg-gradient-to-r from-emerald-50 via-white to-sky-50 px-4 py-5 sm:px-6 sm:py-6 shadow-sm'
        }
      >
        <div className="relative z-10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="min-w-0">
            <p
              className={`mb-1 text-xs font-bold uppercase tracking-wide ${
                isDark ? 'text-emerald-300' : 'text-emerald-700'
              }`}
            >
              Used & scrap parts sellers
            </p>
            <h2
              className={`text-lg font-bold sm:text-xl ${
                isDark ? 'text-white' : 'text-slate-900'
              }`}
            >
              List dismantled parts on Sparepe
            </h2>
            <p className={`mt-1 text-sm ${isDark ? 'text-slate-300' : 'text-slate-600'}`}>
              Register through the partner signup flow.
            </p>
          </div>

          <button
            type="button"
            onClick={handleClick}
            className="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-emerald-500 px-5 py-3 text-sm font-bold text-emerald-950 shadow-lg transition hover:bg-emerald-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300"
          >
            <Recycle className="h-4 w-4" aria-hidden="true" />
            I Sell Used / Scrap Parts
          </button>
        </div>
      </div>
    </motion.section>
  );
};

export default UsedPartsSellerCta;
